import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'

// Views
import ChipIn from './views/ChipIn'
import Success from './views/Success'
import Error from './views/Error'
import Cancel from './views/Cancel'
import AuthError from './views/AuthError'
import Auth from './views/Auth'


Vue.use(VueRouter)

const routes = [

  { 
    path: '/auth', 
    component: Auth, 
    name: 'auth', 
  },
  { 
    path: '/auth-error', 
    component: AuthError, 
    name: 'auth-error', 
  },
  { 
    path: '/success', 
    component: Success, 
    name: 'success', 
  },
  { 
    path: '/cancel', 
    component: Cancel, 
    name: 'cancel', 
  },
    { 
      path: '/', 
      component: ChipIn, 
      name: 'chipin', 
      beforeEnter (to, from, next) {
        if (store.state.accessToken) {
          next()
        } else {
          next('/auth-error')
        }
      }
    },
    { 
      path: '*', 
      component: Error, 
      name: 'error', 
    },
]

export default new VueRouter({mode: 'history', routes})
